﻿import React, {ComponentType, FC, PropsWithChildren} from 'react';
import { GroupSummariesCardItemBackground } from "./GroupSummariesCardItemBackground";
import { GroupSummariesCardItemContainer } from "./GroupSummariesCardItemContainer";
import { GroupSummariesCardItemTitle } from "./GroupSummariesCardItemTitle";
import { GroupSummariesCardItemValue } from "./GroupSummariesCardItemValue";
import {SlotType} from "../../../types/Slots";
import {useSlotOrDefault} from "../../../hooks/slots/useSlotOrDefault";

type GroupSummariesCardItemProps = React.ComponentPropsWithoutRef<'div'> & {
  title: SlotType;
  value: SlotType;
  BackgroundComponent?: ComponentType<PropsWithChildren>;
}

/**
 * Component that displays title/value pairs for the GroupSummariesCard, uses a combination of the proposed slot approaches
 * due to pitfalls of the initial implementation
 * @param title slot for the Title, defaults to GroupSummariesCardItemTitle if own component isn't passed
 * @param value slot for the Value, defaults to GroupSummariesCardItemValue if own component isn't passed
 * @param BackgroundComponent component used for the background, must have children prop
 * @param rest passthrough props to the internal SecurSpace styled MUI Grid
 * @constructor
 */
const GroupSummariesCardItem: FC<GroupSummariesCardItemProps> = ({ title, value, BackgroundComponent = GroupSummariesCardItemBackground, ...rest }) => {
  const Title = useSlotOrDefault(title, GroupSummariesCardItemTitle);
  const Value = useSlotOrDefault(value, GroupSummariesCardItemValue);

  return <GroupSummariesCardItemContainer {...rest}>
    <BackgroundComponent>
      {Title}
      {Value}
    </BackgroundComponent>
  </GroupSummariesCardItemContainer>
}

export { GroupSummariesCardItem };
